// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, ValidateEmail } from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/UpdateAccountSettings";
import translate from "@insite/client-framework/Translate";


// XNG-Change: prevent spaces in emails
const emailRegexp = new RegExp("^\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$");

export const XngValidateEmail: any = (props: any) => {
    const {
        parameter: { email },
    } = props;
    if (typeof email === "undefined") {
        return;
    }

    const requiredFieldMessage = siteMessage("Field_Required", translate("Email Address"));
    const emailFieldMessage = siteMessage("Field_Invalid", translate("Email Address"));

    const errorMessage = email === "" ? requiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
    props.emailErrorMessage = errorMessage as string;
};


replaceInChain(chain, ValidateEmail, XngValidateEmail);

